import styled from "styled-components";
import { gray300, gray700 } from "core/resources/theme/colors";

type Props = {
  value: number | null | undefined;
};

/** RF09 / RN07 — cores só pelo % da API (independente do Status). */
const ORANGE = "#F5A524";
const GREEN = "#22A06B";

function progressTone(pct: number): "idle" | "running" | "done" {
  if (pct >= 100) return "done";
  if (pct > 0) return "running";
  return "idle";
}

function RdoProgressCell({ value }: Props) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return <Dash>-</Dash>;
  }

  // Display only: round + clamp; FE não recalcula % (RN10)
  const pct = Math.max(0, Math.min(100, Math.round(Number(value))));
  const tone = progressTone(pct);

  return (
    <Wrap>
      <Track title={`${pct}%`} $idle={tone === "idle"}>
        {tone !== "idle" && (
          <Fill $tone={tone} style={{ width: `${pct}%` }} />
        )}
      </Track>
      <Pct>{pct}%</Pct>
    </Wrap>
  );
}

export default RdoProgressCell;

const Wrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
`;

const Track = styled.span<{ $idle: boolean }>`
  flex: 1;
  min-width: 48px;
  height: 8px;
  border-radius: 999px;
  background: ${gray300};
  overflow: hidden;
  position: relative;

  ${({ $idle }) =>
    $idle &&
    `
    &::before {
      content: "";
      position: absolute;
      left: 2px;
      top: 50%;
      transform: translateY(-50%);
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #9ca3af;
    }
  `}
`;

const Fill = styled.span<{ $tone: "running" | "done" }>`
  display: block;
  height: 100%;
  min-height: 8px;
  border-radius: 999px;
  background: ${({ $tone }) => ($tone === "done" ? GREEN : ORANGE)};
`;

const Pct = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${gray700};
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  min-width: 2.4em;
  text-align: right;
`;

const Dash = styled.span`
  color: ${gray700};
`;
